module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "promotion-campaign-filters promotion-table-filters ad-d-flex ad-d-flex-between"
  }, [_c('div', {
    staticClass: "promotion-table-filters-left-part ad-d-flex ad-d-flex-start"
  }, [_c('div', {
    staticClass: "ad-d-flex"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.cOpenDrawer
    }
  }, [_vm._v("新建广告计划")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-edit",
      "disabled": ""
    }
  }, [_vm._v("批量修改")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "size": "small",
      "icon": "el-icon-document-copy",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.openCopyModal
    }
  }, [_vm._v("批量复制")]), _vm._v(" "), (_vm.campaign_obj.id) ? _c('el-tag', {
    attrs: {
      "type": "info",
      "closable": ""
    },
    on: {
      "close": _vm.allAds
    }
  }, [_vm._v("已选广告组:" + _vm._s(_vm.campaign_obj.name))]) : _vm._e()], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "广告计划复制",
      "visible": _vm.dialogCopyVisible,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogCopyVisible = $event
      }
    }
  }, [_c('el-row', [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.batchLoading),
      expression: "batchLoading"
    }],
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "广告主账号",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleAccount
    },
    model: {
      value: (_vm.form.advertiser_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "advertiser_id", $$v)
      },
      expression: "form.advertiser_id"
    }
  }, _vm._l((_vm.AccountList), function(item) {
    return _c('el-option', {
      key: item.advertiser_id,
      attrs: {
        "label": item.Fund.name,
        "value": item.advertiser_id
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.Fund.name))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(item.advertiser_id))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "广告组系列",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.campaignLoading),
      expression: "campaignLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择要复制的广告组"
    },
    model: {
      value: (_vm.form.campaign_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "campaign_id", $$v)
      },
      expression: "form.campaign_id"
    }
  }, _vm._l((_vm.CampaignList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogCopyVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.ConfirmCopy
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.adslist,
      "border": "",
      "highlight-current-row": "",
      "height": "450"
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "",
      "label": "计划ID",
      "align": "center",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t" + _vm._s(scope.row.ad_id) + "\t\t\t\t\n\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "",
      "label": "广告计划名称",
      "align": "left",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-link', {
          staticStyle: {
            "font-size": "12px"
          },
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.lookCreative(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "计划状态",
      "align": "center",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 'AD_STATUS_DELIVERY_OK') ? _c('span', [_c('i', {
          staticClass: "fa fa-circle",
          staticStyle: {
            "color": "#4dd599",
            "font-size": "7px",
            "margin-right": "2px"
          }
        }), _vm._v(" " + _vm._s(scope.row.statusName))]) : _c('span', [_c('i', {
          staticClass: "fa fa-circle",
          staticStyle: {
            "color": "#999",
            "font-size": "7px",
            "margin-right": "2px"
          }
        }), _vm._v(" " + _vm._s(scope.row.statusName))]), _vm._v(" "), (scope.row.learning_phase == 'LEARNING') ? _c('span', [_c('img', {
          attrs: {
            "src": scope.row.learn_img
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.status == 'AD_STATUS_AUDIT_DENY') ? _c('span', [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": scope.row.audit_reject_reason,
            "placement": "top-start"
          }
        }, [_c('i', {
          staticClass: "el-icon-warning",
          staticStyle: {
            "color": "#ccc",
            "cursor": "pointer"
          }
        })])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "计划预算",
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.budget_mode == 'BUDGET_MODE_DAY') ? _c('span', [_vm._v(_vm._s(scope.row.budget))]) : (scope.row.budget_mode == 'BUDGET_MODE_INFINITE') ? _c('span', [_vm._v("不限")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.cost",
      "label": "消耗(元)",
      "sortable": "",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出价(元)",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.cpa_bid))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.show",
      "sortable": "",
      "label": "展示",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.click",
      "sortable": "",
      "label": "点击",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.convert",
      "sortable": "",
      "label": "转化数",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.cpi",
      "sortable": "",
      "label": "CPI",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.cpm",
      "sortable": "",
      "label": "CPM",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.ctr",
      "sortable": "",
      "label": "CTR(%)",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.cvr",
      "sortable": "",
      "label": "CVR(%)",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "性别",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.audience.gender == 'NONE' ? '不限' : scope.row.audience.gender == 'GENDER_MALE' ? '男' : '女'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.cvr",
      "label": "所属广告组",
      "align": "center",
      "width": "230"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-link', {
          staticStyle: {
            "font-size": "12px"
          },
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(scope.row.report.campaign_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "投放范围",
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.inventory_type_name), function(item, index) {
          return _c('el-tag', {
            key: index,
            staticStyle: {
              "font-size": "10px"
            },
            attrs: {
              "effect": "dark",
              "size": "mini"
            }
          }, [_vm._v(_vm._s(item))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "flow_control_mode_name",
      "label": "投放方式",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "",
      "label": "操作",
      "align": "center",
      "width": "120",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "color": "#2F88FF"
          },
          attrs: {
            "type": "text",
            "plain": "",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "color": "#6f9a8d"
          },
          attrs: {
            "type": "text",
            "plain": "",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.copyAds(scope.row)
            }
          }
        }, [_vm._v("复制")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "color": "#999"
          },
          attrs: {
            "type": "text",
            "size": "mini"
          }
        }, [_c('el-dropdown', {
          attrs: {
            "trigger": "click"
          }
        }, [_c('i', {
          staticClass: "fa fa-ellipsis-v"
        }), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "icon": "el-icon-document-copy"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.viewLog(scope.row)
            }
          }
        }, [_vm._v("日志")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "icon": "el-icon-circle-plus"
          }
        }, [_vm._v("诊断")])], 1)], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "disabled": this.sels.length === 0,
      "icon": "el-icon-check",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.updateStatus('enable')
      }
    }
  }, [_vm._v("开启")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning",
      "icon": "el-icon-video-pause",
      "disabled": this.sels.length === 0,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.updateStatus('disable')
      }
    }
  }, [_vm._v("暂停")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "el-icon-delete",
      "size": "small",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.updateStatus('delete')
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,sizes,prev, pager, next",
      "page-size": _vm.pagesize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _vm._v(" "), _c('AdsEditPanel', {
    ref: "AdsEditDrawer",
    on: {
      "getAds": _vm.getAds
    }
  }), _vm._v(" "), _c('LogPanel', {
    ref: "logDrawer"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4463d44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adv/model/ads.vue
// module id = 1107
// module chunks = 36